import { parse } from "papaparse";
export default class ImportService {
  dataToImport: any;
  hasDataToImport = false;
  columns: Array<string> = [];
  selectedColumn = "";

  useHeaderRow = true;

  get previewLength() {
    if (!this.dataToImport) {
      return 0;
    }

    if (this.selectedColumn !== "") {
      return this.dataToImport.filter(
        (item: any) => item[this.selectedColumn] != ""
      ).length;
    }

    return this.dataToImport.length;
  }

  get preview() {
    if (this.dataToImport === "") return "";

    let preview: any = [];
    if (this.selectedColumn != "") {
      for (
        let index = 0;
        index < 4 && index < this.dataToImport.length;
        index++
      ) {
        preview.push(this.dataToImport[index][this.selectedColumn]);
      }
    } else {
      for (
        let index = 0;
        index < 4 && index < this.dataToImport.length;
        index++
      ) {
        preview.push(this.dataToImport[index]);
      }
    }

    return preview;
  }

  Parse(source: string | File | NodeJS.ReadableStream) {
    const that = this;

    const config = {
      delimiter: "", // auto-detect
      newline: "", // auto-detect
      header: this.useHeaderRow,
      skipEmptyLines: true,
      complete: (results: any) => {
        that.dataToImport = results.data;
        that.hasDataToImport = true;

        that.SetColumns(results.meta.fields);
      },
    };

    parse(source, config);
  }

  SetColumns(fields: any) {
    if (fields.length && this.useHeaderRow) {
      let autoSelectIndex = 0;
      const possibleUrlColumns = ["domain", "url"];
      let columnRegex = new RegExp(possibleUrlColumns.join("|"), "i");

      this.columns = fields.filter((f: any) => {
        if (columnRegex.test(f) && autoSelectIndex == 0) {
          autoSelectIndex = fields.indexOf(f);
        }

        return f !== "";
      });

      if (this.columns.length) {
        this.selectedColumn = this.columns[autoSelectIndex];
      }
    }
  }
  ReadFromFile(file: File) {
    //
    // If all checks are passed,
    // continue reading the file
    const reader = new FileReader();

    reader.onload = (e: Event) => {
      if (e.target) {
        const data = (e.target as FileReader).result;
        this.Parse(data as string);
      }
    };

    reader.readAsText(file);
  }
  Dispose() {
    this.columns = [];
    this.hasDataToImport = false;
    this.dataToImport = [];
    this.selectedColumn = "";
  }
}
